module.exports = __webpack_public_path__ + "img/trash-bucket.79991cbd.svg";